<template>
  <div class="trialNotes">
    <!-- 返回抽审工单按钮 -->
    <el-button @click="back" class="csjl" type="primary">{{$t('lang.back_trialList')}}</el-button>
    <div class="filters">
      <el-form :inline="true">
        <!-- 起止日期 -->
        <el-form-item>
          <el-date-picker v-model="datevalues" type="daterange" :range-separator="$t('lang.lab_to')"
            :start-placeholder="$t('lang.lab_startDate')" :end-placeholder="$t('lang.lab_endDate')"
            value-format="timestamp"></el-date-picker>
        </el-form-item>
        <!-- 抽审名称 -->
        <el-form-item>
          <el-input :placeholder="$t('lang.trialNotes_write_name')" v-model="drawName"></el-input>
        </el-form-item>
        <!-- 负责人 -->
        <el-form-item>
          <el-input :placeholder="$t('lang.trialNotes_write_leader')" v-model="chargeLeader"></el-input>
        </el-form-item>
        <!-- 查询按钮 -->
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName" :height="tableData.length>0 ? require('@/config/enum').tableheight540 : require('@/config/enum').tableheight120">
        <!-- 多选框 -->
        <el-table-column type="selection" width="55" v-if="this.trialNotescheckbox"></el-table-column>
        <!-- 序号 -->
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
        <!-- id -->
        <el-table-column prop="Id" :label="$t('lang.lab_Id')" width="100px">
        </el-table-column>
        <!-- 抽审名称 -->
        <el-table-column :label="$t('lang.trialNotes_name')" prop=Name width="300px">
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light" v-if="scope.row.Name&&scope.row.Name.length>require('@/config/enum').tableDatamaxlength50"
              :disabled="false">
              <div slot="content">
                <span>
                  {{ scope.row.Name}}
                </span>
              </div>
              <div>
                {{ scope.row.Name.substring(0, require('@/config/enum').tableDatamaxlength50) | valueIsNull }}
                <span v-if="scope.row.Name.length>require('@/config/enum').tableDatamaxlength50">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.Name | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 负责人 -->
        <el-table-column :label="$t('lang.trialNotes_leader')" prop=StaffName width="200px">
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light" v-if="scope.row.StaffName&&scope.row.StaffName.length>require('@/config/enum').tableDatamaxlength12"
              :disabled="false">
              <div slot="content">
                <span>
                  {{ scope.row.StaffName }}
                </span>
              </div>
              <div>
                {{ scope.row.StaffName.substring(0, require('@/config/enum').tableDatamaxlength12) | valueIsNull }}
                <span v-if="scope.row.StaffName.length>require('@/config/enum').tableDatamaxlength12">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.StaffName | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 抽审日期 -->
        <el-table-column :label="$t('lang.trialNotes_date')" prop=RItime width="200px" sortable>
          <template slot-scope="scope">{{scope.row.RItime | time}}</template>
        </el-table-column>
        <!-- 抽审数据总数 -->
        <el-table-column :label="$t('lang.trialNotes_total')" prop=total width="120px">
        </el-table-column>
        <!-- 优秀数 -->
        <el-table-column label="优秀数" prop=youxiu width="120px">
        </el-table-column>
        <!-- 合格数 -->
        <el-table-column :label="$t('lang.trialNotes_qualified')" prop=hege width="120px">
        </el-table-column>
        <!-- 不合格数 -->
        <el-table-column :label="$t('lang.trialNotes_unqualified')" prop=buhege width="120px">
        </el-table-column>
        <!-- 状态 -->
        <el-table-column :label="$t('lang.trialNotes_state')" prop=State min-width="160px">
          <template slot-scope="scope">
            <span v-if="scope.row.State === 0" class="red">{{$t('lang.trialNotes_state_uncomplete')}}</span>
            <span v-if="scope.row.State === 1" class="green">{{$t('lang.trialNotes_state_complete')}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.lab_operation')" prop="operation" fixed="right"
          :width="require('@/config/enum').opr_width1">
          <!-- 详情按钮 -->
          <template slot-scope="scope">
            <el-button @click="detail(scope.row)">{{$t('lang.trialDetailBtn')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>

  </div>
</template>

<script>
  /**
   *@ClassName:trialNotes
   *@Description:抽审记录
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-05-12
   */
  import {
    mapGetters
  } from 'vuex'
  export default {
    name:'/manage/trialNotes',
    data() {
      return {
        pageCount: 0, // 总页数
        pageNum: 1, // 第几页
        pageSize: 10, // 每页显示数
        datevalues: '', // 开始结束时间绑定值
        drawName: '', // 抽审名称
        chargeLeader: '', // 负责人
        tableData: [], // 抽审记录列表
        trialNotescheckbox: require('@/config/enum').trialNotescheckbox, // 是否隐藏复选框
      }
    },
    computed: {
      ...mapGetters(['gardenId', 'groupId'])
    },
    created() {
      // 获取抽审记录列表方法
      this.getList()
    },
    methods: {
      // 返回抽审工单
      back() {
        this.$router.push({
          name: 'trialOrderList'
        })
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      // 隔行变色
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNum = val
        this.getList()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNum = 1
        this.pageSize = val
        this.getList()
      },
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // 查询按钮
      commit() {
        this.pageNum = 1
        this.getList()
      },
      // 抽审记录列表方法
      getList() {
        var startTs = '' // 开始时间
        var endTs = '' // 结束时间
        if (this.datevalues != null) {
          if (this.datevalues.length > 0) {
            startTs = this.datevalues[0]
            endTs = this.datevalues[1]
            console.log(startTs)
            console.log(endTs)
          }
        }
        let loading = this.$loading()
        this.$get(
          `/randomInspections?pageNo=${this.pageNum}&pageSize=${this.pageSize}&riName=${this.drawName}&principal=${this.chargeLeader}&startTs=${startTs}&endTs=${endTs}&groupId=${this.groupId}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              // 渲染抽审记录列表
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 抽审记录详情方法
      detail(row) {
        this.$router.push({
          name: 'trialDetailList',
          query: { row: row }
        })
      }
    }
  }
</script>

<style lang="scss">
.trialNotes .filters{
    background: #fff;
    border-radius: 6px;
    margin-bottom: 20px;
    padding: 20px 20px 20px 20px;
    -webkit-box-shadow: 0 4px 8px 0 #eaeaea;
    box-shadow: 0 4px 8px 0 #eaeaea;
  }
  .trialNotes .filters .el-form--inline .el-form-item{
    margin-bottom: 0;
  }
  .trialNotes .csjl {
    float: right;
    margin: 20px;
  }
  .trialNotes .green{
    color:rgb(0, 128, 0);
  }
</style>